import { configureStore } from "@reduxjs/toolkit";
// import dashboard from "./reducers/customerAgentDashboard";
import statusTable from "./reducers/customerStatusTable";
import customerAgentDetails from "./reducers/customerAgentDetailsDashboard";
import orderStatus from "./reducers/orderStatus";
import auth from "./reducers/authSlice";
import orderLog from "./reducers/orderLog";
import plansSlice from "./reducers/plansSlice";
import devicesSlice from "./reducers/devicesSlice";
import addonsSlice from "./reducers/addonsSlice";
import credentialsSlice from "./reducers/credentialsSlice";
import healthReducer from "./reducers/healthCheckSlice";

export const store = configureStore({
  reducer: {
    auth: auth,
    statusTable: statusTable,
    customerAgentDetails: customerAgentDetails,
    orderStatus: orderStatus,
    orderLog: orderLog,
    plansData: plansSlice,
    deviceData: devicesSlice,
    addonsData: addonsSlice,
    credentialsData: credentialsSlice,
    health: healthReducer,
  },
});
